import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const SECCIONES_CONST = 'secciones';
export const seccionesApi = `${baseUrl}/${SECCIONES_CONST}`;

export const allSeccionesService = async (params) => {
  const res = await axios.get(seccionesApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveSeccionesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${seccionesApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(seccionesApi, data, { headers: token({}) });
  }
  return res;
};

export const oneSeccionesService = async (idEntidad, id) => {
  const res = await axios.get(`${seccionesApi}/${id}`, {
    headers: token({}),
    params: { idEntidad },
  });
  return res;
};

export const deleteSeccionesService = async (idEntidad, id) => {
  const res = await axios.delete(`${seccionesApi}/${id}`, {
    headers: token({}),
    params: { idEntidad },
  });
  return res;
};
